import { Box, Text } from "@chakra-ui/react";

interface TimeColumnProps {
  startHour?: number;
  endHour?: number;
  hourHeight?: number;
}

export function TimeColumn({
  startHour = 6,
  endHour = 23,
  hourHeight = 90
}: TimeColumnProps) {
  const hours = Array.from(
    { length: endHour - startHour + 1 },
    (_, i) => startHour + i
  );

  return (
    <Box
      w="60px"
      flexShrink={0}
      bg="white"
      borderRight="1px"
      borderColor="gray.200"
    >
      {hours.map((hour) => (
        <Box
          key={hour}
          h={`${hourHeight}px`}
          borderTop="1px"
          borderColor="gray.200"
          position="relative"
          pr={2}
        >
          <Text
            fontSize="xs"
            color="gray.600"
            position="absolute"
            top="-10px"
            right="4px"
            bg="white"
            px={2.5}
            fontWeight="medium"
          >
            {String(hour).padStart(2, '0')}:00
          </Text>
        </Box>
      ))}
    </Box>
  );
}
